
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post5() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Dúvida saúde - geral - Experiência lidando com diabetes</title>
        <meta 
          name="description" 
          content="Quando fui diagnosticado com diabetes, já uns 8 anos atrás, meu primeiro sentimento foi de revolta. Porque eu?, eu pensava. Nem muito acima do peso eu estava. Porém com o tempo fui aceitando e aprendendo a viver com essa nova realidade. No fim, diabetes mudou minha vida e a forma como eu vivo. E apesar da minha revolta inicial, a maioria dessas mudanças foi para o bem. Pensando a respeito, resolvi escrever algumas coisas que aprendi desde meu diagnóstico e que talvez sejam úteis para outras pessoas.

Já vou começar pelo mais importante: a primeira coisa que aprendi foi que nenhum tratamento para diabetes funciona sozinho. Diabetes, talvez mais que qualquer outra doença crônica, precisa ser gerenciada pelo paciente, porque quase qualquer coisa que nós fazemos tem um efeito no nosso nível de glicose no sangue.

Para diabetes não tem uma pílula milagrosa que o médico vai receitar, nós (quem tem diabetes) precisa participar ATIVAMENTE do tratamento, tomando controle da nossa saúde, estudando e aprendendo sobre a doença. 

Isso é muito trabalhoso, mas recompensador, porque mostra o nosso poder em controlar e influenciar (pelo menos parcialmente) a nossa saúde.

A melhor coisa que fiz logo no início, e recomendo para quem tem diabetes, é comprar um medidor de glicose, aprender a utilizar o aparelho, e medir a glicose todos os dias (e no início, mais de uma vez ao dia). Isso foi super importante para aprender como meu nível de glicose funciona, e como as coisas que afetam ele (diferentes comidas, diferentes rotinas de exercício físico). Depois de um ano fazendo isso, eu já tinha uma boa ideia de como meu corpo e meu nível de glicose respondiam aos vários estímulos, e não precisei mais medir com tanta frequência. 

O segundo ponto importante é a alimentação. Não vou falar de dieta diretamente, porque imagino que seja diferente para cada pessoa, mas limitar a quantidade de comida foi uma das coisas mais importantes que fiz: me ajudou chegar no peso ideal e ter mais energia e disposição. Uma coisa posso falar com segurança: o controle de diabetes se beneficia da redução de calorias ingeridas, e fiz isso principalmente trocando outras carnes por peixe e aumentando a quantidade de vegetais no meu prato.

Depois de colocar a alimentação em ordem, a terceira coisa mais importante que fiz foi começar a me exercitar. O truque aqui foi encontrar uma maneira de fazer exercício ser algo que eu gostava. Para mim, o que funcionou foi começar a fazer natação, algo que eu sempre tinha vontade de fazer, mas nunca tinha começado. A diabetes foi o catalisador para isso, e hoje todas as semanas, gosto muito e me faz muito bem.

Espero que essa minha experiência sirva e possa dar algumas ideias para quem está começando a enfrentar essa situação agora. Com controle e esforço, é possível viver com uma qualidade de vida ainda melhor do que antes da diabetes!!"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            T. Estudante &#183; 23/07/2024
          </p>
        </div>
        <p className="heading4 bottom-margin-s">Experiência lidando com diabetes</p>


        <p className="body content bottom-padding-s">
            Quando fui diagnosticado com diabetes, já uns 8 anos atrás, meu primeiro sentimento foi de revolta. Porque eu?, eu pensava. Nem muito acima do peso eu estava. Porém com o tempo fui aceitando e aprendendo a viver com essa nova realidade. No fim, diabetes mudou minha vida e a forma como eu vivo. E apesar da minha revolta inicial, a maioria dessas mudanças foi para o bem. Pensando a respeito, resolvi escrever algumas coisas que aprendi desde meu diagnóstico e que talvez sejam úteis para outras pessoas.<br/><br/>Já vou começar pelo mais importante: a primeira coisa que aprendi foi que nenhum tratamento para diabetes funciona sozinho. Diabetes, talvez mais que qualquer outra doença crônica, precisa ser gerenciada pelo paciente, porque quase qualquer coisa que nós fazemos tem um efeito no nosso nível de glicose no sangue.<br/><br/>Para diabetes não tem uma pílula milagrosa que o médico vai receitar, nós (quem tem diabetes) precisa participar ATIVAMENTE do tratamento, tomando controle da nossa saúde, estudando e aprendendo sobre a doença. <br/><br/>Isso é muito trabalhoso, mas recompensador, porque mostra o nosso poder em controlar e influenciar (pelo menos parcialmente) a nossa saúde.<br/><br/>A melhor coisa que fiz logo no início, e recomendo para quem tem diabetes, é comprar um medidor de glicose, aprender a utilizar o aparelho, e medir a glicose todos os dias (e no início, mais de uma vez ao dia). Isso foi super importante para aprender como meu nível de glicose funciona, e como as coisas que afetam ele (diferentes comidas, diferentes rotinas de exercício físico). Depois de um ano fazendo isso, eu já tinha uma boa ideia de como meu corpo e meu nível de glicose respondiam aos vários estímulos, e não precisei mais medir com tanta frequência. <br/><br/>O segundo ponto importante é a alimentação. Não vou falar de dieta diretamente, porque imagino que seja diferente para cada pessoa, mas limitar a quantidade de comida foi uma das coisas mais importantes que fiz: me ajudou chegar no peso ideal e ter mais energia e disposição. Uma coisa posso falar com segurança: o controle de diabetes se beneficia da redução de calorias ingeridas, e fiz isso principalmente trocando outras carnes por peixe e aumentando a quantidade de vegetais no meu prato.<br/><br/>Depois de colocar a alimentação em ordem, a terceira coisa mais importante que fiz foi começar a me exercitar. O truque aqui foi encontrar uma maneira de fazer exercício ser algo que eu gostava. Para mim, o que funcionou foi começar a fazer natação, algo que eu sempre tinha vontade de fazer, mas nunca tinha começado. A diabetes foi o catalisador para isso, e hoje todas as semanas, gosto muito e me faz muito bem.<br/><br/>Espero que essa minha experiência sirva e possa dar algumas ideias para quem está começando a enfrentar essa situação agora. Com controle e esforço, é possível viver com uma qualidade de vida ainda melhor do que antes da diabetes!!
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/5')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  3 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi!<br/><br/>Muito obrigado por compartilhar sua experiência com a gente. Tenho certeza de que suas dicas e aprendizados serão de grande ajuda para outras pessoas que estão começando a lidar com o diabetes.<br/><br/>É inspirador ler como você transformou a revolta inicial em motivação para tomar controle da sua saúde. Realmente, diabetes é uma condição que requer bastante dedicação e cuidado diário, mas é incrível ver como seu esforço foi recompensador.<br/><br/>Você tocou em pontos essenciais:<br/>1. **Medir a glicose regularmente**: Esse é realmente o primeiro passo para entender como seu corpo responde a diferentes alimentos e atividades.<br/>2. **Alimentação balanceada**: Limitar calorias e fazer escolhas mais saudáveis, como incluir mais vegetais e peixes, pode fazer uma grande diferença.<br/>3. **Atividade física**: Encontrar uma atividade que você goste, como a natação no seu caso, é fundamental para manter-se ativo de forma prazerosa.<br/><br/>Tenho certeza que sua mensagem vai motivar e tranquilizar muitas pessoas que estão passando pela fase de aceitação do diagnóstico. Isso mostra que, com dedicação e controle, é possível não só conviver com o diabetes como até melhorar a qualidade de vida.<br/><br/>Se alguém tiver dúvidas ou precisar de mais orientações, sempre lembrem de consultar um médico ou profissional de saúde. E continuem compartilhando suas jornadas, pois histórias como a sua são muito valiosas para todos nós!<br/><br/>Um grande abraço e parabéns pela sua dedicação!<br/><br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 06/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/5')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Paula Farber &#183; 18/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/125-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Pessoal com diabetes tipo 1. Quais os legumes vocês mais usam no dia a dia?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/125')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Georgina Klar &#183; 19/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/131-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia Gente<br/>Eu fui no Cardiologista<br/>Ele disse que 125 ainda é Pré diabetes e tem como reverter comendo frutas, verduras, comidas integral e tirando açúcar que volta o normal<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/131')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Rita Anton &#183; 12/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/79-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, sou hipertensa e hoje minha pressão diastólica não saiu do 10 ou 9 ....<br/>A sistólica fica entre 12 e 13 e a diastólica entre 9 e 10.<br/>Oque vocês acham que eu devo fazer?<br/>Já tomei o remédio da pressão as 18 horas tomo a cada 12 horas, mas tenho ansiedade e não estou nem conseguindo dormir porque a pressão não abaixa.<br/>Já tá me dando até dor de cabeça
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/79')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Danna Rosa &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/45-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, boa tarde. Me tirem uma dúvida.<br/>Diabético pode usar açúcar mascavo no lugar do açúcar normal?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/45')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Elisa Orta &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/36-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde pessoal,<br/><br/>Vocês que tem hipertensão primária, fizeram exames pra investigar? Quais?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/36')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
